// extracted by mini-css-extract-plugin
export var chevronIcon = "_sz-1";
export var edgeToggle = "_sz-0";